import React from 'react';
import Row from '../ui/Row';
import Col from '../ui/Col';
import RestClient from '../rest/RestClient';
import MicroEvent  from '../other/microevent';
import Config from '../Config';
import Container from 'react-bootstrap/esm/Container';

export default class RecoveryPassConfirm extends React.Component {

  state = {
    submitStarted:false,
    submitFailed: false,
    submitSucceeded: false,
  }

  constructor(props) {
    super(props);

    MicroEvent.mixin(RecoveryPassConfirm);

    this.state = {
      showErrors:                         false,
      restError:                          null,
    }
  }

  componentDidMount() {
    this.submit();
  }

  submit = () => {

    this.setState({showErrors: true});
    this.setState({ submitStarted: true });
    this.setState({ submitFailed: false });
    this.setState({ submitSucceeded: false });

    RestClient.forgotPassConfirm(this.props.match.params.key, this.props.match.params.email, () => {
      //this is to do the another entrance in order to automatically select newly added account
      //Entrance.silentEnter();
      //<-
      this.setState({ submitStarted: false });
      this.setState({ submitFailed: false });
      this.setState({ submitSucceeded: true });

    },
    (error) => {
      //console.log('authentication error');
      this.setState({ restError: error});
      this.setState({ submitStarted: false });
      this.setState({ submitFailed: true });
    })
  }

  render() {

    if (this.state.submitSucceeded) { //it is flag of success indeed
      return (
        <div className="login-page">
          <Container>
            <Row>
              <p>Check your email for the new password.</p>
            </Row>
            <Row>
              <p>You can change it later after {"\u00a0"}<a href={Config.appURI}>logging in</a>.</p>
            </Row>
          </Container>
        </div>
      )
    }

    var authMessage1 = (this.state.submitStarted)
        ? (<p>Resetting password...</p>):'';

    var authMessage2 = (this.state.submitFailed)
        ? (<p class="text-red">Password reset failed: <i>{this.state.restError.message}</i></p>):'';

    return  (
      <div className="login-page">
        <Container>
          <Row>
            <Col>
            {authMessage1}
            {authMessage2}
            </Col>
          </Row>
        </Container>
      </div>
     );
   }
 }
